module.exports = __webpack_public_path__ + "img/592.2593af13.jpg";